// extracted by mini-css-extract-plugin
export default {"container":"f0-z","heading":"g0-z","links":"h0-z","copy":"i0-z","subCopy":"j0-z","linksLeft":"k0-z","linksCenter":"l0-z","linksRight":"m0-z","link":"n0-z","onlyLink":"o0-z"};